import { useState } from "react";
import { Image as ImageIcon, Megaphone, Video } from "lucide-react";
import { normalizeAdReply } from "@/lib/ad-reply";

interface AdReplyCardProps {
  adReply: unknown;
}

/** Card de contexto "respondeu a um anúncio" (Click-to-WhatsApp). */
export function AdReplyCard({ adReply }: AdReplyCardProps) {
  const [expanded, setExpanded] = useState(false);
  const ad = normalizeAdReply(adReply);
  if (!ad) return null;

  const bodyIsLong = (ad.body?.length ?? 0) > 140;
  const showBody = ad.body && ad.body !== ad.headline;

  const inner = (
    <div className="flex gap-3 min-w-0">
      {ad.thumbnailUrl ? (
        <img
          src={ad.thumbnailUrl}
          alt="Criativo do anúncio"
          className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
          loading="lazy"
        />
      ) : ad.mediaKind ? (
        <div className="w-12 h-12 rounded-lg flex-shrink-0 flex items-center justify-center bg-pink-500/10 text-pink-600 dark:text-pink-400">
          {ad.mediaKind === "video" ? <Video className="w-5 h-5" /> : <ImageIcon className="w-5 h-5" />}
        </div>
      ) : null}

      <div className="min-w-0 flex-1">
        <span className="text-xs font-semibold flex items-center gap-1 text-pink-600 dark:text-pink-400">
          <Megaphone className="w-3.5 h-3.5 flex-shrink-0" />
          Respondeu a um anúncio no {ad.platformLabel}
        </span>

        {ad.headline && (
          <span className="text-xs font-medium block text-foreground/90 mt-0.5">{ad.headline}</span>
        )}

        {showBody && (
          <span
            className={`text-xs block whitespace-pre-wrap text-foreground/70 mt-0.5 ${
              expanded ? "" : "line-clamp-2"
            }`}
          >
            {ad.body}
          </span>
        )}

        {showBody && bodyIsLong && (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setExpanded((v) => !v);
            }}
            className="text-[11px] mt-0.5 text-pink-600 dark:text-pink-400 hover:underline"
          >
            {expanded ? "ver menos" : "ver anúncio completo"}
          </button>
        )}

        {ad.title && ad.title !== ad.headline && (
          <span className="text-[11px] block text-muted-foreground mt-0.5">
            Botão do anúncio: {ad.title}
          </span>
        )}
      </div>
    </div>
  );

  return (
    <div className="border-l-4 pl-3 pr-2 py-2.5 mb-2 rounded-r-md min-w-0 border-pink-400 bg-black/5 dark:bg-white/5">
      {ad.sourceUrl ? (
        <a href={ad.sourceUrl} target="_blank" rel="noopener noreferrer" className="block hover:opacity-90">
          {inner}
        </a>
      ) : (
        inner
      )}
    </div>
  );
}
